import PropTypes from "prop-types";

export const author = PropTypes.shape({
    avatarSrc: PropTypes.string,
    id: PropTypes.number,
    isCertified: PropTypes.bool,
    isChatbot: PropTypes.bool,
    isElite: PropTypes.bool,
    isOfficial: PropTypes.bool,
    isOriginalPoster: PropTypes.bool,
    lastActiveDate: PropTypes.string,
    name: PropTypes.string,
    reputation: PropTypes.shape({
        helpfulnessScore: PropTypes.number,
        numberOfAnswers: PropTypes.number,
    }),
});

export const message = PropTypes.shape({
    author,
    actions: PropTypes.array,
    customerRepliedToMarkAsResolved: PropTypes.bool,
    dateCreated: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isFirstResponseMessage: PropTypes.bool,
    isLoading: PropTypes.bool,
    lastUpdated: PropTypes.string,
    messageText: PropTypes.string,
    messageTextHtml: PropTypes.string,
    rawMessageText: PropTypes.string,
    resolved: PropTypes.bool,
    responseId: PropTypes.number,
    type: PropTypes.string,
    viewedByUser: PropTypes.bool,
});

export const question = PropTypes.shape({
    author,
    body: PropTypes.string,
    closeQuestionWhenEscalated: PropTypes.bool,
    company: PropTypes.string,
    confirmAccepts: PropTypes.bool,
    dateClosed: PropTypes.string,
    dateCreated: PropTypes.string,
    hasOfficialMessages: PropTypes.bool,
    isAnswered: PropTypes.bool,
    isInteractionAllowed: PropTypes.bool,
    isLastMessageMarkedAsResolvedBy: PropTypes.bool,
    lastUpdated: PropTypes.string,
    rawBody: PropTypes.string,
    reroutingStatus: PropTypes.object,
    status: PropTypes.number,
    subject: PropTypes.string,
    type: PropTypes.string,
    unreadMessageCount: PropTypes.number,
    uuid: PropTypes.string,
    chatTranscriptAsJson: PropTypes.object,
});

export const response = PropTypes.shape({
    author,
    body: PropTypes.string,
    clusterId: PropTypes.string,
    customerHappiness: PropTypes.string,
    dateCreated: PropTypes.string,
    happiness: PropTypes.string,
    happinessLastUpdated: PropTypes.string,
    id: PropTypes.number,
    isAccepted: PropTypes.bool,
    isLeavingRating: PropTypes.bool,
    isLeavingTestimonial: PropTypes.bool,
    isViewedByUser: PropTypes.bool,
    lastUpdated: PropTypes.string,
    messages: PropTypes.array,
    quickReply: PropTypes.string,
    ratingInProgress: PropTypes.bool,
    recognitionRecipient: PropTypes.object,
    responseMessageAuthor: author,
    showChatbotNameAndAvatar: PropTypes.bool,
    testimonialDateCreated: PropTypes.string,
});

export default {
    message,
    question,
    response,
};
